import http from "./http-service"

export default class BoletoService {

  static getTitle(data) {
    return http.post("getTitle", data).then((response) => response)
  }

  static getBoleto(data) {
    return http.post("haveBoleto", data).then((response) => response)
  }

  static getPDFBoleto(data) {
    return http.post("pdfBoleto", data).then((response) => response)
  }
}